import { all, call, put } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { getAreaTeams } from '../../redux';
function* handleGetAreaTeams({ payload }) {
    const { areaId } = payload;
    try {
        const response = (yield call(Api.getAreaTeams, areaId));
        const statistics = (yield all(response.data.data.reduce((acc, { team_id }) => ({
            ...acc,
            [team_id]: call(Api.getAreaTeamStatistics, team_id),
        }), {})));
        const successPayload = {
            data: response.data.data.map((team) => ({
                ...team,
                ...statistics[team.team_id].data.data.statistics,
            })),
        };
        yield put(getAreaTeams.success(successPayload));
    }
    catch (error) {
        yield put(getAreaTeams.failure(error));
    }
}
export default handleGetAreaTeams;
